export enum ClientTxState {
  ClientStart = 'ClientStart',
  Prerequisites = 'Prerequisites',
  PrerequisiteInProcess = 'PrerequisiteInProcess',
  Summary = 'Summary',
  DocumentRead = 'DocumentRead',
  DocumentOpen = 'DocumentOpen',
  Signing = 'Signing',
  ExternalSigning = 'ExternalSigning',
  SignConflict = 'SignConflict',
  ProcessingSignature = 'ProcessingSignature',
  Finalized = 'Finalized',
}
